import { takeLatest } from 'redux-saga/effects';
import types from './actions-types';
import {
  getDailyRentContractsSaga,
  getListOfDRContractsForExcelSaga,
  closeContractSaga,
  getCloseContractDetailsSaga,
  saveContractRefundSaga,
  saveContractPaySaga,
  getTotalPaySaga,
  cancelPromissoryNoteSaga,
  sendCanceledPromissoryNoteSaga,
} from './sagas';

export default function* watchers() {
  yield takeLatest(types.GET_LIST, getDailyRentContractsSaga);
  yield takeLatest(
    types.GET_LIST_OF_DR_CONTRACTS_FOR_EXCEL,
    getListOfDRContractsForExcelSaga
  );
  yield takeLatest(types.CLOSE_CONTRACT, closeContractSaga);
  yield takeLatest(
    types.GET_CLOSE_CONTRACT_DETAILS,
    getCloseContractDetailsSaga
  );
  yield takeLatest(types.SAVE_CONTRACT_REFUND, saveContractRefundSaga);
  yield takeLatest(types.SAVE_CONTRACT_PAY, saveContractPaySaga);
  yield takeLatest(types.GET_TOTAL_PAY, getTotalPaySaga);
  yield takeLatest(types.CANCEL_PROMISSORY_NOTE, cancelPromissoryNoteSaga);
  yield takeLatest(
    types.SEND_CANCELED_PROMISSORY_NOTE,
    sendCanceledPromissoryNoteSaga
  );
}
